/**
 * ОПЦИОНАЛЬНО (обертка над sliceSidebar)
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isHideSelector, isPinnedSelector, setIsHide, setIsPinned } from './sidebarSlice';

export default function useSidebar() {
  const dispatch = useDispatch();
  const isPinned = useSelector(isPinnedSelector);
  const isHide = useSelector(isHideSelector);

  const onChangePinned = React.useCallback((value: boolean) => {
    dispatch(setIsPinned(value));
  }, [dispatch]);

  const onChangeHide = React.useCallback((value: boolean) => {
    dispatch(setIsHide(value));
  }, [dispatch]);

  return {
    isPinned,
    isHide,
    onChangePinned,
    onChangeHide,
  };
}
